// designestate scope
import * as deesComms from '@design.estate/dees-comms';

export { deesComms };

// apiglobal scope
import * as typedrequest from '@api.global/typedrequest';

export { typedrequest };

// pushrocks scope
import * as smartdelay from '@push.rocks/smartdelay';
import * as smartjson from '@push.rocks/smartjson';
import * as smartmarkdown from '@push.rocks/smartmarkdown';
import * as smartpromise from '@push.rocks/smartpromise';
import * as smartrouter from '@push.rocks/smartrouter';
import * as smartrx from '@push.rocks/smartrx';
import * as smartstate from '@push.rocks/smartstate';
import * as smartstring from '@push.rocks/smartstring';
import * as smarturl from '@push.rocks/smarturl';
import * as webrequest from '@push.rocks/webrequest';
import * as websetup from '@push.rocks/websetup';
import * as webstore from '@push.rocks/webstore';

// subscope lik
import { ObjectMap } from '@push.rocks/lik/dist_ts/lik.objectmap.js';
import { Stringmap } from '@push.rocks/lik/dist_ts/lik.stringmap.js';
import { FastMap } from '@push.rocks/lik/dist_ts/lik.fastmap.js';
const lik = {
  ObjectMap,
  Stringmap,
  FastMap,
};

export {
  lik,
  smartdelay,
  smartjson,
  smartmarkdown,
  smartpromise,
  smartrouter,
  smartrx,
  smarturl,
  smartstate,
  smartstring,
  webrequest,
  websetup,
  webstore,
};

// third party scope
import Lenis from 'lenis'
import SweetScroll from 'sweet-scroll';

export { Lenis, SweetScroll };
